let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aJJUY"), load("gr9Xf"), load("68WuS")]).then(() => parcelRequire('fUqEj'));